import type { CustomerMetadata } from '~/utils/rudderstack/types'

export function useCustomerMetadata() {
  const config = useRuntimeConfig()
  const { user } = useUserSession()
  const { count } = useLicenseInformation()

  const { data: subscriptions } = useSubscriptions({
    // TODO: Remove this when we have API for just fetching Juridika subscriptions
    select: data => data.filter(it => it.customerOriginId === config.public.hubspotPortalId || it.customerOriginId === null),
  })

  return computed((): CustomerMetadata | undefined => {
    // TODO: Maybe add companyId from Hubspot here?
    const customerNumber = user?.value?.activeOrganization?.number
    const customerName = user?.value?.activeOrganization?.name
    const subscription = subscriptions?.value?.find(it => it.customerOriginId === customerNumber)
    // TODO: Find out where this information is stored
    const marketCategory = 'unknown'
    const potentialUsers = count?.value || 0
    const subscriptionPackage = subscription?.productName
    const subscriptionStatus = subscription?.status

    return {
      customerNumber,
      customerName,
      marketCategory,
      potentialUsers,
      subscriptionPackage,
      subscriptionStatus,
    }
  })
}
